import { gql } from '@apollo/client';
import { getUserFields } from './user';
import { FR_ORGANIZATION_FIELDS, ORGANIZATION_FIELDS_FRAGMENT } from './fragments/organizations';

const user_fields = getUserFields();

export const GET_ORGANIZATIONS = gql`
    query Organizations {
        organizations {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const GET_ORGANIZATION_PLAN = gql`
    query OrganizationPlan ($OrganizationId: Int!)  { 
			organization( data: { OrganizationId: $OrganizationId}) {
				OrganizationId
				Name

				Plan {
					PlanId
					Name

					UserGroups {
						Name
						Users {
							UserId
							Firstname
							Lastname

							${user_fields}
						}
					}
				}
    }}
`;

export const GET_ORGANIZATION_BYID = gql`
    query OrganizationById($OrganizationId: Int!) {
        organization(data: { OrganizationId: $OrganizationId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const GET_ORGANIZATION_USERS = gql(
    `
query orgusers($OrganizationId: Int!) {
	organization( data: { OrganizationId: $OrganizationId}) {
		OrganizationStakeholders {
			` +
        user_fields +
        `
			
		}
		OrganizationEmployees {
			` +
        user_fields +
        `
		}
	}
}`
);

export const GET_ORGANIZATIONS_JUST_NAME_ID = gql`
    query organizationsNameId {
        organizations {
            OrganizationId
            Name
        }
    }
`;

export const GET_ORGANIZATION_SUBSCRIPTIONS = gql`
    query subscriptions($orgId: Int!) {
        subscriptions(data: { OrganizationId: $orgId }) {
            SubscriptionId
            UserGroup {
                Users {
                    Firstname
                    Lastname
                }
            }
        }
    }
`;

export const GET_ORGANIZATION_SUBSCRIPTION_SUMMARY = gql`
    query SubscriptionSummary($OrganizationId: Int!) {
        organization(data: { OrganizationId: $OrganizationId }) {
            Name
            Bin
            SubscriptionSummary {
                SubscriptionName
                Count
                MaxCount
            }
        }
    }
`;

export const UPDATE_ORGANIZATION = gql`
    mutation updateOrganization(
        $OrganizationId: Int!
        $Name: String
        $Bin: String
        $WebPageUrl: String
        $Logo: String
        $BusinessLine: String
        $Address: UpdateAddressInputType
        $Theme: UpdateThemeInputType
        $RemovePartnerOrganizations: [UpdateOrganizationRemovePartnerInputType!]
        $AddPartnerOrganizations: [UpdateOrganizationAddPartner!]
        $AddEmergencyPerson: [CreateOrganizationEmergencyPersonInputType!]
        $RemoveEmergencyPerson: [UpdateOrganizationRemoveEmergencyPersonInputType!]
    ) {
        updateOrganization(
            data: {
                OrganizationId: $OrganizationId
                Name: $Name
                Bin: $Bin
                Address: $Address
                WebPageUrl: $WebPageUrl
                Logo: $Logo
                BusinessLine: $BusinessLine
                Theme: $Theme
                RemovePartnerOrganizations: $RemovePartnerOrganizations
                AddPartnerOrganizations: $AddPartnerOrganizations
                AddEmergencyPerson: $AddEmergencyPerson
                RemoveEmergencyPerson: $RemoveEmergencyPerson
            }
        ) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const CREATE_ORGANIZATION = gql`
    mutation createOrganization(
        $Name: String!
        $Bin: String!
        $Address: AddressInputType!
        $WebPageUrl: String
        $BusinessLine: String
        $LogoUrl: String
        $Theme: CreateThemeInputType
    ) {
        createOrganization(
            data: {
                Name: $Name
                Bin: $Bin
                Address: $Address
                WebPageUrl: $WebPageUrl
                BusinessLine: $BusinessLine
                LogoUrl: $LogoUrl
                Theme: $Theme
            }
        ) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPLOAD_ORGANIZATION_LOGO = gql`
    mutation uploadOrganizationLogo($File: Upload!, $OrganizationId: Int!) {
        uploadOrganizationLogo(data: { File: $File, OrganizationId: $OrganizationId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPLOAD_DASHBOARD_BGIMAGE = gql`
    mutation uploadDashBoardBgImage($File: Upload!, $ThemeId: Int!) {
        uploadDashBoardBgImage(data: { File: $File, ThemeId: $ThemeId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPLOAD_DASHBOARD_IMAGE = gql`
    mutation uploadDashBoardImage($File: Upload!, $ThemeId: Int!) {
        uploadDashBoardImage(data: { File: $File, ThemeId: $ThemeId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPLOAD_LOGINBACKGROUND_IMAGE = gql`
    mutation uploadLoginBackground($File: Upload!, $ThemeId: Int!) {
        uploadLoginBackground(data: { File: $File, ThemeId: $ThemeId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const UPLOAD_UPLOADTHEMEORGANIZATION_LOGO = gql`
    mutation uploadThemeOrganizationLogo($File: Upload!, $ThemeId: Int!) {
        uploadThemeOrganizationLogo(data: { File: $File, ThemeId: $ThemeId }) {
            ...OrganizationFields
        }
    }
    ${ORGANIZATION_FIELDS_FRAGMENT}
`;

export const GET_ORGANIZATION_ROWS = gql`
    query organizationRows($From: Int, $To: Int, $TextSearch: String) {
        organizationRows(data: { From: $From, To: $To, TextSearch: $TextSearch }) {
            TotalRowCount
            Organization {
                ...fr_OrganizationFields
            }
        }
    }
    ${FR_ORGANIZATION_FIELDS}
`;
